/**
 * @file Video
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { useStyleTransform } from '../hooks/useStyleTransform';
import { H5Video } from './H5Video';
export var Video = forwardRef(function (props, ref) {
    var id = props.id, _a = props.style, elemStyle = _a === void 0 ? {} : _a, _b = props.className, elemClassName = _b === void 0 ? '' : _b, children = props.children, onClick = props.onClick, extra = __rest(props, ["id", "style", "className", "children", "onClick"]);
    var config = useStyleTransform(elemStyle, 'xj-h5-video', elemClassName);
    var videoRef = useRef(null);
    useImperativeHandle(ref, function () { return videoRef.current; });
    return (React.createElement("div", __assign({}, config, { id: id, onClick: onClick }),
        React.createElement(H5Video, __assign({ ref: videoRef }, extra), children)));
});
